module.exports = __webpack_public_path__ + "img/daudet.0599406f.jpg";